import axios from 'axios';
import { API_BASE_URL } from '../config/api.config';

const API_URL = API_BASE_URL;

export interface PermissionModule {
  _id: string;
  name: string;
  path: string;
  category: string;
  icon?: string;
  permissions: string[];
  isActive: boolean;
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePermissionModuleInput {
  name: string;
  path: string;
  category: string;
  icon?: string;
  permissions: string[];
}

export interface UpdatePermissionModuleInput {
  name?: string;
  path?: string;
  category?: string;
  icon?: string;
  permissions?: string[];
  isActive?: boolean;
}

export const permissionModuleService = {
  async getAllModules(token: string, filters?: { isActive?: boolean; category?: string }): Promise<PermissionModule[]> {
    const response = await axios.get(`${API_URL}/permission-modules`, {
      headers: { Authorization: `Bearer ${token}` },
      params: filters || {}
    });
    return response.data.data;
  },

  async getModuleById(id: string, token: string): Promise<PermissionModule> {
    const response = await axios.get(`${API_URL}/permission-modules/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  async createModule(data: CreatePermissionModuleInput, token: string): Promise<PermissionModule> {
    const response = await axios.post(`${API_URL}/permission-modules`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  async updateModule(id: string, data: UpdatePermissionModuleInput, token: string): Promise<PermissionModule> {
    const response = await axios.put(`${API_URL}/permission-modules/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  async deleteModule(id: string, token: string): Promise<void> {
    await axios.delete(`${API_URL}/permission-modules/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
};
